export default __webpack_public_path__ + "static/media/athlete-small.9c7a85d4.png";